<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.userAuthorityGroups') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{ $ml.get('shared.settings') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.userAuthorityGroups') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('userAuthorityGroups.userAuthorityGroupList') }}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText" class="form-control"
                style="margin-bottom:10px;" autocomplete="false" />
              <div v-show="userAuthorityGroupList.length > 0" class="table-responsive no-padding"
                :style="windowHeightSize">
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="userAuthority in userAuthorityGroupList" :key="userAuthority.id">
                      <td>{{ userAuthority.name }}</td>
                      <td class="pull-right">
                        <button type="button" @click="getUserAuthorityGroup(userAuthority.id)"
                          class="btn btn-primary btn-sm">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="userAuthorityGroupList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('userAuthorityGroups.userAuthorityGroupNotRecord') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{ $ml.get('userAuthorityGroups.userAuthorityGroupInformation') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0" type="button" @click="newUserAuthorityGroup()"
                  class="btn btn-sm btn-warning">{{ $ml.get('userAuthorityGroups.newAuthorityGroup') }}</button>
              </div>
            </div>
            <div class="box-body">
              <div class="form-group col-sm-12">
                <label>{{ $ml.get('userAuthorityGroups.authorityGroupName') }}</label>
                <input v-model="userAuthorityGroup.name" type="text" class="form-control" autocomplete="off" />
              </div>
              <div class="form-group col-sm-12">
                <label>{{ $ml.get('userAuthorityGroups.description') }}</label>
                <input v-model="userAuthorityGroup.description" type="text" class="form-control" autocomplete="off" />
              </div>
              <div class="col-sm-6">
                <div class="form-group form-control">
                  <div class="radio" style="margin-left:20px;">
                    <label>
                      <input :checked="userAuthorityGroup.state == 0" @change="userAuthorityGroup.state = 0"
                        type="radio" name="optionsRadios" id="optionsRadios1" value="option1" />
                      {{ $ml.get('userAuthorityGroups.admin') }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group form-control">
                  <div class="radio" style="margin-left:20px;">
                    <label>
                      <input :checked="userAuthorityGroup.state == 1" @change="userAuthorityGroup.state = 1"
                        type="radio" name="optionsRadios" id="optionsRadios2" value="option2" />
                      {{ $ml.get('userAuthorityGroups.user') }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="callout callout-warning">
                  <h4>{{ $ml.get('userAuthorityGroups.filterAuthorities') }}</h4>
                  <span>*{{ $ml.get('userAuthorityGroups.authorityInfo') }}</span>
                </div>
                <hr />
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>{{ $ml.get('filters.filterDepartments') }}</label>
                      <div class="input-group">
                        <label v-show="checkedDepartmentList != ''" class="form-control tdb-box">{{
                          checkedDepartmentList }}</label>
                        <label v-show="checkedDepartmentList == ''" class="form-control">{{
                          $ml.get('general.notSelected') }}</label>
                        <div class="input-group-btn">
                          <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-department">
                            <i class="fa fa-search"></i>
                          </button>
                          <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                            @click="clearFilterDepartments()">
                            <i class="fa fa-remove"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('filters.filterStatus') }}</label>
                      <div class="input-group">
                        <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList
                          }}</label>
                        <label v-show="checkedStatusList == ''" class="form-control">{{ $ml.get('general.notSelected')
                          }}</label>
                        <div class="input-group-btn">
                          <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                            <i class="fa fa-search"></i>
                          </button>
                          <button v-show="checkedStatusList != ''" class="btn btn-danger" @click="clearFilterStatus()">
                            <i class="fa fa-remove"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('filters.filterState') }}</label>
                      <div class="input-group">
                        <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList
                          }}</label>
                        <label v-show="checkedStateList == ''" class="form-control">{{ $ml.get('general.notSelected')
                          }}</label>
                        <div class="input-group-btn">
                          <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                            <i class="fa fa-search"></i>
                          </button>
                          <button v-show="checkedStateList != ''" class="btn btn-danger" @click="clearFilterStates()">
                            <i class="fa fa-remove"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedAccessGroupList != ''" class="form-control tdb-box">{{
                        checkedAccessGroupList }}</label>
                      <label v-show="checkedAccessGroupList == ''" class="form-control">{{
                        $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                          @click="clearFilterAccessGroup()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                    <div class="input-group">
                      <label v-show="checkedWorkGroupList != ''" class="form-control tdb-box">{{ checkedWorkGroupList
                        }}</label>
                      <label v-show="checkedWorkGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-workplan">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                          @click="clearFilterWorkPlans()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 form-group" v-show="modules.diningHall">
                    <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedFoodGroupList != ''" class="form-control tdb-box">{{ checkedFoodGroupList
                        }}</label>
                      <label v-show="checkedFoodGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-diningHall">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                          @click="clearFilterFoodGroups()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('filters.filterAllowence') }}</label>
                    <div class="input-group">
                      <label v-show="checkedAllowenceList != ''" class="form-control tdb-box">{{ checkedAllowenceList
                        }}</label>
                      <label v-show="checkedAllowenceList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-allowence">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedAllowenceList != ''" class="btn btn-danger"
                          @click="clearFilterAllowences()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="callout callout-danger">
                  <h4>{{ $ml.get('userAuthorityGroups.authorities') }}</h4>
                </div>
                <hr />
                <div class="row">
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('shared.dashboard') }}</label>
                    <select @change="changeDashboardStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.dashboard == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.dashboard == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('shared.employees') }}</label>
                    <select @change="changeUsersStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authUsers == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authUsers == 1" value="1">
                        {{ $ml.get('userAuthorityGroups.onlyView') }}</option>
                      <option :selected="userAuthorityGroup.authUsers == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('shared.definitions') }}</label>
                    <select @change="changeDefinitionsStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authDefinitions == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authDefinitions == 1" value="1">
                        {{ $ml.get('userAuthorityGroups.onlyView') }}</option>
                      <option :selected="userAuthorityGroup.authDefinitions == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('shared.userAuthorityGroups') }}</label>
                    <select @change="changeAccessGroupsStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authAccessGroups == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authAccessGroups == 1" value="1">
                        {{ $ml.get('userAuthorityGroups.onlyView') }}</option>
                      <option :selected="userAuthorityGroup.authAccessGroups == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('shared.realTimeMonitor') }}</label>
                    <select @change="changeRealTimeMonitorStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authRealTimeMonitor == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authRealTimeMonitor == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('shared.reports') }}</label>
                    <select @change="changeReportsStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authReports == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authReports == 1" value="1">
                        {{ $ml.get('userAuthorityGroups.onlyView') }}</option>
                      <option :selected="userAuthorityGroup.authReports == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label>{{ $ml.get('shared.settings') }}</label>
                    <select @change="changeSettingsStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authSettings == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authSettings == 1" value="1">
                        {{ $ml.get('userAuthorityGroups.onlyView') }}</option>
                      <option :selected="userAuthorityGroup.authSettings == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group" v-show="modules.diningHall">
                    <label>{{ $ml.get('shared.foodGroups') }}</label>
                    <select @change="changeFoodStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authFood == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authFood == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group" v-show="modules.visitor">
                    <label>{{ $ml.get('shared.visitors') }}</label>
                    <select @change="changeVisitorStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.authVisitor == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.authVisitor == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group" v-show="modules.retailSale">
                    <label>{{ $ml.get('shared.retailSale') }}</label>
                    <select @change="changeCreditSaleStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.creditSale == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.creditSale == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group" v-show="modules.payrollManagement">
                    <label>{{ $ml.get('shared.payrollManagement') }}</label>
                    <select @change="changePayrollManagementStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.payrollManagement == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.payrollManagement == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group" v-show="modules.guardTour">
                    <label>{{ $ml.get('shared.guardTourSystem') }}</label>
                    <select @change="changeGuardTourStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.guardTour == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.guardTour == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6 form-group" v-show="modules.shiftManagement">
                    <label>{{ $ml.get('shared.shiftManagement') }}</label>
                    <select @change="changeShiftManagementStatu($event)" class="form-control">
                      <option :selected="userAuthorityGroup.shiftManagement == 0" value="0">
                        {{ $ml.get('userAuthorityGroups.fullAuthority') }}</option>
                      <option :selected="userAuthorityGroup.shiftManagement == 2" value="2">
                        {{ $ml.get('userAuthorityGroups.cantUse') }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-12" v-show="modules.shiftManagement">
                <div class="callout callout-info">
                  <h4>Vardiya (Shift) Yönetimi Ayarları</h4>
                </div>
                <hr />
                <div class="row">
                  <div class="col-sm-12 col-md-6 form-group">
                    <label>Shift Planlama</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :disabled="userAuthorityGroup.shiftManagement == 2"
                          :checked="userAuthorityGroup.shiftSettings.canPlan"
                          @change="userAuthorityGroup.shiftSettings.canPlan == true ? userAuthorityGroup.shiftSettings.canPlan = false : userAuthorityGroup.shiftSettings.canPlan = true"
                          type="checkbox" />
                        Shift planlayabilsin
                      </label>
                    </span>
                  </div>
                  <div class="col-sm-12 col-md-6 form-group">
                    <label>Shift Onaylama</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :disabled="userAuthorityGroup.shiftManagement == 2"
                          :checked="userAuthorityGroup.shiftSettings.canConfirmShift"
                          @change="userAuthorityGroup.shiftSettings.canConfirmShift == true ? userAuthorityGroup.shiftSettings.canConfirmShift = false : userAuthorityGroup.shiftSettings.canConfirmShift = true"
                          type="checkbox" />
                        Shift onaylayabilsin
                      </label>
                    </span>
                  </div>
                  <div class="col-sm-12 col-md-6 form-group">
                    <label>İzin Planlama</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :disabled="userAuthorityGroup.shiftManagement == 2"
                          :checked="userAuthorityGroup.shiftSettings.canPlanAllowence"
                          @change="userAuthorityGroup.shiftSettings.canPlanAllowence == true ? userAuthorityGroup.shiftSettings.canPlanAllowence = false : userAuthorityGroup.shiftSettings.canPlanAllowence = true"
                          type="checkbox" />
                        İzin planlayabilsin
                      </label>
                    </span>
                  </div>
                  <div class="col-sm-12 col-md-6 form-group">
                    <label>İzin Onaylama</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :disabled="userAuthorityGroup.shiftManagement == 2"
                          :checked="userAuthorityGroup.shiftSettings.canConfirmAllowence"
                          @change="userAuthorityGroup.shiftSettings.canConfirmAllowence == true ? userAuthorityGroup.shiftSettings.canConfirmAllowence = false : userAuthorityGroup.shiftSettings.canConfirmAllowence = true"
                          type="checkbox" />
                        İzin onaylayabilsin
                      </label>
                    </span>
                  </div>
                  <div class="col-sm-12 form-group">
                    <label>Gerçekleşen Takvimi</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :disabled="userAuthorityGroup.shiftManagement == 2"
                          :checked="userAuthorityGroup.shiftSettings.canSeeRealMovements"
                          @change="userAuthorityGroup.shiftSettings.canSeeRealMovements == true ? userAuthorityGroup.shiftSettings.canSeeRealMovements = false : userAuthorityGroup.shiftSettings.canSeeRealMovements = true"
                          type="checkbox" />
                        Gerçekleşen takvimi görüntüleyebilsin
                      </label>
                    </span>
                  </div>
                  <div class="col-sm-12 form-group">
                    <label>Onaylanmamış Plan Uyarısı</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :disabled="userAuthorityGroup.shiftManagement == 2"
                          :checked="userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts"
                          @change="userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts == true ? userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts = false : userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts = true"
                          type="checkbox" />
                        Onaylanmamış plan olduğunda uyarı e-postası gönderilsin
                      </label>
                    </span>
                  </div>
                  <div class="col-sm-12 form-group">
                    <label>Onaylanmamış Plan Uyarı Tekrarı</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :disabled="userAuthorityGroup.shiftManagement == 2"
                          :checked="userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay"
                          @change="userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay == true ? userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay = false : userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay = true"
                          type="checkbox" />
                        Onaylanmamış plan tekrarı olduğunda uyarı e-postası gönderilsin
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button v-show="!isNewUserAuthorityGroup && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-sil" class="btn btn-sm btn-danger" style="margin: 5px; width:120px;">{{
                    $ml.get('general.delete') }}</button>
                <button v-show="isNewUserAuthorityGroup && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-kaydet" class="btn btn-sm btn-success" style="margin: 5px; width:120px;">{{
                    $ml.get('general.save') }}</button>
                <button v-show="!isNewUserAuthorityGroup && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-guncelle" class="btn btn-sm btn-success" style="margin: 5px; width:120px;">{{
                    $ml.get('general.update') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.userAuthorityGroup.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('userAuthorityGroups.isContinueUserAuthGroupUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveUserAuthorityGroup()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.userAuthorityGroup.name }}</p>
              <span>{{ $ml.get('userAuthorityGroups.isContinueUserAuthGroupSave') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveUserAuthorityGroup()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.userAuthorityGroup.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('userAuthorityGroups.isContinueUserAuthGroupDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteUserAuthorityGroup()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterDepartments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
              </a>
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText2" class="form-control"
                style="margin-bottom:10px;margin-top:10px;" autocomplete="false" />
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="dep.id">
                  <label style="margin-left:20px;">
                    <input :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox" />
                    {{ dep.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                  {{ $ml.get('employees.departmentNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" M data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterState') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                  <label style="margin-left:20px;">
                    <input :checked="state.isCheck"
                      @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                    {{ state.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="stateList.length == 0">
                  {{ $ml.get('employees.stateNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterStatus') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                  <label style="margin-left:20px;">
                    <input :checked="status.isCheck"
                      @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true"
                      type="checkbox" />
                    {{ status.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="statuList.length == 0">
                  {{ $ml.get('employees.statusNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                  <label style="margin-left:20px;">
                    <input :checked="acc.isCheck"
                      @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true" type="checkbox" />
                    {{ acc.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                  {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="work in periodWorkGroupList" :key="work.id">
                  <label style="margin-left:20px;">
                    <input :checked="work.isCheck"
                      @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true" type="checkbox" />
                    {{ work.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="periodWorkGroupList.length == 0">
                  {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="foodGroup in foodGroupList" :key="foodGroup.id">
                  <label style="margin-left:20px;">
                    <input :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                      type="checkbox" />
                    {{ foodGroup.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                  {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
      <!--İZİN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-allowence" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAllowence') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="allowence in allowenceList" :key="allowence.id">
                  <label style="margin-left:20px;">
                    <input :checked="allowence.isCheck"
                      @change="allowence.isCheck == true ? allowence.isCheck = false : allowence.isCheck = true"
                      type="checkbox" />
                    {{ allowence.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="allowenceList.length == 0">
                  {{ $ml.get('allowences.allowenceNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--İZİN SEÇ MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      userAuthorityGroup: {
        id: null,
        name: "",
        description: "",
        state: 0,
        authUsers: 0,
        authAccessGroups: 0,
        authReports: 0,
        authSettings: 0,
        authDefinitions: 0,
        authRealTimeMonitor: 0,
        authFood: 0,
        authVisitor: 0,
        creditSale: 0,
        dashboard: 0,
        guardTour: 0,
        payrollManagement: 0,
        shiftManagement: 0,
        shiftSettings: {
          canPlan: true,
          canConfirmShift: true,
          canConfirmAllowence: true,
          canPlanAllowence: true,
          canSeeRealMovements: true,
          sendMailWhenUnconfirmedShifts: false,
          sendWarningMailOnSecondDay: false
        },
        filter: {
          departments: [],
          accessGroup: [],
          foodGroup: [],
          workGroupId: [],
          stateId: [],
          statuId: [],
          allowenceId: []
        }
      },
      isNewUserAuthorityGroup: true,
      userAuthorityGroups: [],
      searchText2: "",
      isCheckDeps: false,
      departments: [],
      sortableDepTrees: [],
      foodGroups: [],
      accessGroups: [],
      states: [],
      status: [],
      workGroups: [],
      allowences: []
    };
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    userAuthorityGroupList() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.userAuthorityGroups.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v));
        });
      } else {
        return this.userAuthorityGroups;
      }
    },
    departmentList() {
      return this.departments.filter(a => {
        return a.isActive == true;
      });
    },
    sortableDepartmentList() {
      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.sortableDepTrees.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) &&
                item.isActive == true
            );
        });
      } else {
        return this.sortableDepTrees.filter(a => {
          return a.isActive == true;
        });
      }
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    stateList() {
      return this.states;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList() {
      return this.status;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    periodWorkGroupList() {
      return this.workGroups
        .filter(item => {
          return item.isPeriod == true || item.model == 4 || item.model == 3;
        })
        .sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 0;
        });
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    allowenceList() {
      return this.allowences.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 0;
      });
    },
    checkedAllowenceList() {
      var checkedList = "";
      var list = this.allowenceList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    changeUsersStatu(event) {
      this.userAuthorityGroup.authUsers = event.target.value;
    },
    changeDefinitionsStatu(event) {
      this.userAuthorityGroup.authDefinitions = event.target.value;
    },
    changeAccessGroupsStatu(event) {
      this.userAuthorityGroup.authAccessGroups = event.target.value;
    },
    changeRealTimeMonitorStatu(event) {
      this.userAuthorityGroup.authRealTimeMonitor = event.target.value;
    },
    changeReportsStatu(event) {
      this.userAuthorityGroup.authReports = event.target.value;
    },
    changeSettingsStatu(event) {
      this.userAuthorityGroup.authSettings = event.target.value;
    },
    changeFoodStatu(event) {
      this.userAuthorityGroup.authFood = event.target.value;
    },
    changeVisitorStatu(event) {
      this.userAuthorityGroup.authVisitor = event.target.value;
    },
    changeDashboardStatu(event) {
      this.userAuthorityGroup.dashboard = event.target.value;
    },
    changeCreditSaleStatu(event) {
      this.userAuthorityGroup.creditSale = event.target.value;
    },
    changePayrollManagementStatu(event) {
      this.userAuthorityGroup.payrollManagement = event.target.value;
    },
    changeGuardTourStatu(event) {
      this.userAuthorityGroup.guardTour = event.target.value;
    },
    changeShiftManagementStatu(event) {
      this.userAuthorityGroup.shiftManagement = event.target.value;
    },
    filtersClear() {
      this.searchText2 = "";
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.periodWorkGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
      this.allowenceList.forEach(a => {
        a.isCheck = false;
      });
    },
    setUserAuthorityFilter(filter) {
      this.userAuthorityGroup.filter.departments = filter.departments;
      this.sortableDepartmentList.forEach(doc => {
        filter.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.userAuthorityGroup.filter.workGroupId = filter.workGroupId;
      this.periodWorkGroupList.forEach(doc => {
        filter.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.allowenceId = filter.allowenceId;
      this.allowenceList.forEach(doc => {
        filter.allowenceId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.accessGroup = filter.accessGroup;
      this.accessGroupList.forEach(doc => {
        filter.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.foodGroup = filter.foodGroup;
      this.foodGroupList.forEach(doc => {
        filter.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.stateId = filter.stateId;
      this.stateList.forEach(doc => {
        filter.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.statuId = filter.statuId;
      this.statuList.forEach(doc => {
        filter.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    newUserAuthorityGroup() {
      this.isLoadingDetail = true;
      this.isNewUserAuthorityGroup = true;
      this.userAuthorityGroup.id = null;
      this.userAuthorityGroup.name = "";
      this.userAuthorityGroup.description = "";
      this.userAuthorityGroup.state = 0;
      this.userAuthorityGroup.authUsers = 0;
      this.userAuthorityGroup.authAccessGroups = 0;
      this.userAuthorityGroup.authReports = 0;
      this.userAuthorityGroup.authSettings = 0;
      this.userAuthorityGroup.authDefinitions = 0;
      this.userAuthorityGroup.authRealTimeMonitor = 0;
      this.userAuthorityGroup.authFood = 0;
      this.userAuthorityGroup.authVisitor = 0;
      this.userAuthorityGroup.creditSale = 0;
      this.userAuthorityGroup.dashboard = 0;
      this.userAuthorityGroup.payrollManagement = 0;
      this.userAuthorityGroup.shiftManagement = 0;
      this.userAuthorityGroup.shiftSettings = {
        canPlan: true,
        canConfirmShift: true,
        canConfirmAllowence: true,
        canPlanAllowence: true,
        canSeeRealMovements: true,
        sendMailWhenUnconfirmedShifts: false,
        sendWarningMailOnSecondDay: false
      };
      this.userAuthorityGroup.filter = {
        departments: [],
        accessGroup: [],
        foodGroup: [],
        workGroupId: [],
        stateId: [],
        statuId: [],
        allowenceId: []
      };
      this.filtersClear();
      this.isLoadingDetail = false;
    },
    async deleteUserAuthorityGroup() {
      try {
        this.isLoadingDetail = true;
        let id = this.userAuthorityGroup.id;
        const response = await this.$axios
          .delete("/UserAuthorityGroups/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getUserAuthorityGroups();
        this.newUserAuthorityGroup();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async saveUserAuthorityGroup() {
      if (this.isNewUserAuthorityGroup) {
        if (this.userAuthorityGroup.name == "") {
          alertify.warning(this.$ml.get("alerts.pleaseEnterAName"));
          return;
        }
        this.isLoadingDetail = true;
        await this.getCheckDepartmentList();
        try {
          let userAuthorityGroup2 = this.userAuthorityGroup;
          const response = await this.$axios
            .post("/UserAuthorityGroups", {
              name: userAuthorityGroup2.name,
              description: userAuthorityGroup2.description,
              state: userAuthorityGroup2.state,
              authUsers: userAuthorityGroup2.authUsers,
              authAccessGroups: userAuthorityGroup2.authAccessGroups,
              authReports: userAuthorityGroup2.authReports,
              authSettings: userAuthorityGroup2.authSettings,
              authDefinitions: userAuthorityGroup2.authDefinitions,
              authRealTimeMonitor: userAuthorityGroup2.authRealTimeMonitor,
              authFood: userAuthorityGroup2.authFood,
              authVisitor: userAuthorityGroup2.authVisitor,
              creditSale: userAuthorityGroup2.creditSale,
              dashboard: userAuthorityGroup2.dashboard,
              payrollManagement: userAuthorityGroup2.payrollManagement,
              guardTour: userAuthorityGroup2.guardTour,
              shiftManagement: userAuthorityGroup2.shiftManagement,
              shiftSettings: userAuthorityGroup2.shiftSettings,
              filter: userAuthorityGroup2.filter
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getUserAuthorityGroups();
          this.getUserAuthorityGroup(id);
          this.isNewUserAuthorityGroup = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        await this.getCheckDepartmentList();
        try {
          let userAuthorityGroup2 = this.userAuthorityGroup;
          const response = await this.$axios
            .post("/UserAuthorityGroups/" + userAuthorityGroup2.id, {
              name: userAuthorityGroup2.name,
              description: userAuthorityGroup2.description,
              state: userAuthorityGroup2.state,
              authUsers: userAuthorityGroup2.authUsers,
              authAccessGroups: userAuthorityGroup2.authAccessGroups,
              authReports: userAuthorityGroup2.authReports,
              authSettings: userAuthorityGroup2.authSettings,
              authDefinitions: userAuthorityGroup2.authDefinitions,
              authRealTimeMonitor: userAuthorityGroup2.authRealTimeMonitor,
              authFood: userAuthorityGroup2.authFood,
              authVisitor: userAuthorityGroup2.authVisitor,
              creditSale: userAuthorityGroup2.creditSale,
              dashboard: userAuthorityGroup2.dashboard,
              payrollManagement: userAuthorityGroup2.payrollManagement,
              guardTour: userAuthorityGroup2.guardTour,
              shiftManagement: userAuthorityGroup2.shiftManagement,
              shiftSettings: userAuthorityGroup2.shiftSettings,
              filter: userAuthorityGroup2.filter
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getUserAuthorityGroups();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      }
    },
    async getUserAuthorityGroup(id) {
      try {
        await this.filtersClear();
        this.isLoadingDetail = true;
        const response = await this.$axios
          .get("/UserAuthorityGroups/" + id)
          .then(response => {
            this.isNewUserAuthorityGroup = false;
            this.userAuthorityGroup.id = id;
            this.userAuthorityGroup.name = response.data.name;
            this.userAuthorityGroup.description = response.data.description;
            this.userAuthorityGroup.state = response.data.state;
            this.userAuthorityGroup.authUsers = response.data.authUsers;
            this.userAuthorityGroup.authAccessGroups =
              response.data.authAccessGroups;
            this.userAuthorityGroup.authReports = response.data.authReports;
            this.userAuthorityGroup.authSettings = response.data.authSettings;
            this.userAuthorityGroup.authDefinitions =
              response.data.authDefinitions;
            this.userAuthorityGroup.authRealTimeMonitor =
              response.data.authRealTimeMonitor;
            this.userAuthorityGroup.authFood = response.data.authFood;
            this.userAuthorityGroup.authVisitor = response.data.authVisitor;
            this.userAuthorityGroup.creditSale = response.data.creditSale;
            this.userAuthorityGroup.dashboard = response.data.dashboard;
            this.userAuthorityGroup.guardTour = response.data.guardTour
              ? response.data.guardTour
              : this.userAuthorityGroup.guardTour;
            this.userAuthorityGroup.payrollManagement =
              response.data.payrollManagement;
            this.userAuthorityGroup.shiftManagement =
              response.data.shiftManagement;
            this.userAuthorityGroup.shiftSettings = response.data.shiftSettings
              ? response.data.shiftSettings
              : this.userAuthorityGroup.shiftSettings;
            this.userAuthorityGroup.filter = response.data.filter;
            if (response.data.filter) {
              this.setUserAuthorityFilter(response.data.filter);
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getUserAuthorityGroups() {
      try {
        this.isLoading = true;
        const userAuthorityGroups = [];
        const response = await this.$axios
          .get("/UserAuthorityGroups")
          .then(response => {
            response.data.forEach(doc => {
              userAuthorityGroups.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.userAuthorityGroups = userAuthorityGroups;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async clearFilterDepartments() {
      this.userAuthorityGroup.filter.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.userAuthorityGroup.filter.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.userAuthorityGroup.filter.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.userAuthorityGroup.filter.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.userAuthorityGroup.filter.workGroupId = [];
      await this.periodWorkGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterAllowences() {
      this.userAuthorityGroup.filter.allowenceId = [];
      await this.allowenceList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.userAuthorityGroup.filter.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDep = !this.isCheckDep;
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
        /*if (doc.id == dep.mainDepartmentId && checkValue) {
          doc.check = true;
        }*/
      });
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.userAuthorityGroup.filter.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.userAuthorityGroup.filter.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.userAuthorityGroup.filter.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.userAuthorityGroup.filter.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.periodWorkGroupList;
      this.userAuthorityGroup.filter.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.userAuthorityGroup.filter.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.userAuthorityGroup.filter.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.userAuthorityGroup.filter.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.userAuthorityGroup.filter.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.userAuthorityGroup.filter.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.userAuthorityGroup.filter.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.userAuthorityGroup.filter.stateId.push(doc.id);
        }
      });
      let aList7 = this.allowenceList;
      this.userAuthorityGroup.filter.allowenceId = [];
      await aList7.forEach(doc => {
        if (doc.isCheck == true) {
          this.userAuthorityGroup.filter.allowenceId.push(doc.id);
        }
      });
    },
    async getDepartments() {
      try {
        this.isLoadingDetail = true;
        const departments = [];
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                check: false
              });
              departments.sort((a, b) => {
                if (a.locationTree < b.locationTree) return -1;
                if (a.locationTree > b.locationTree) return 0;
              });
            });
            this.departments = departments;
            this.sortableTrees();
            this.isLoadingDetail = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                status: doc.status,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                shortCode: doc.shortCode,
                isPeriod: doc.isPeriod,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAllowences() {
      try {
        this.isLoading = true;
        const allowences = [];
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                monthlyPayrollId: doc.monthlyPayrollId,
                dailyPayrollId: doc.dailyPayrollId,
                dayTime: doc.dayTime,
                colorCode: doc.colorCode,
                r: doc.r,
                g: doc.g,
                b: doc.b,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getDepartments();
    await this.getFoodGroups();
    await this.getAccessGroups();
    await this.getStatus();
    await this.getStates();
    await this.getWorkGroups();
    await this.getAllowences();
    await this.getUserAuthorityGroups();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/userAuthorityGroups/UserAuthorityGroups.vue